import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionItemCategoryApi = {
    getInstitutionItemCategoriesByInstitutionId: (institutionId?: number): Observable<Dtos.GetInstitutionItemCategoriesByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionItemCategoriesByInstitutionId = new Dtos.GetInstitutionItemCategoriesByInstitutionId();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionItemCategoriesByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}